import React, { useEffect, useState } from 'react';
import { NAV_ITEMS } from '../../constants/navigation.js';
import { useNavigate, useLocation } from 'react-router-dom';

const Navigation = ({ currentPage, setCurrentPage, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [openMenu, setOpenMenu] = useState(null);

  /* ---------- RESPONSIVE ---------- */
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  /* ---------- AUTO SYNC SUBMENU WITH URL ---------- */
  useEffect(() => {
    NAV_ITEMS.forEach(item => {
      if (item.children) {
        const childMatch = item.children.find(child => child.path === location.pathname);
        if (childMatch) {
          setOpenMenu(item.label);
        }
      }
      if (item.path === location.pathname) {
        setOpenMenu(item.children ? item.label : null);
      }
    });
  }, [location.pathname]);

  /* ---------- NAVIGATION ---------- */
  const goTo = (item, parent = null) => {
    const pageKey = item.page || item.label;
    setCurrentPage(pageKey);

    if (item.path) navigate(item.path);

    // 🔑 CONTROL SUBMENU STATE HERE
    if (item.children) {
      setOpenMenu(item.label); // open its submenu
    } else if (parent) {
      setOpenMenu(parent); // keep parent open when clicking child
    } else {
      setOpenMenu(null); // close all if normal menu
    }

    if (isMobile && onClose) onClose();
  };

  return (
    <nav className="py-4">
      <ul className="space-y-1">
        {NAV_ITEMS.map((item) => {
          const hasChildren = item.children?.length > 0;
          const isOpen = openMenu === item.label;
          const isActive = currentPage === (item.page || item.label);

          return (
            <li key={item.label}>
              {/* MAIN ITEM */}
              <button
                onClick={() => goTo(item)}
                className={`w-full flex justify-between items-center px-4 py-2 text-left transition-all text-base ${
                  isActive
                    ? 'bg-overlay accent-amber border-l-2 border-amber-600'
                    : 'text-secondary hover:accent-amber hover:bg-surface-elevated'
                }`}
              >
                <span>{item.label}</span>
                {hasChildren && (
                  <span className={`transition-transform ${isOpen ? 'rotate-90' : ''}`}>
                    ▶
                  </span>
                )}
              </button>

              {/* SUBMENU */}
              {hasChildren && isOpen && (
                <ul className="ml-4 mt-1 space-y-1 border-l border-slate-700 pl-3">
                  {item.children.map((child) => {
                    const childActive = currentPage === (child.page || child.label);
                    return (
                      <li key={child.label}>
                        <button
                          onClick={() => goTo(child, item.label)}
                          className={`w-full text-left px-3 py-2 text-sm rounded-md transition-all ${
                            childActive
                              ? 'bg-violet-700/30 text-amber-300'
                              : 'text-slate-400 hover:text-amber-300 hover:bg-slate-800'
                          }`}
                        >
                          {child.label}
                        </button>
                      </li>
                    );
                  })}
                </ul>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Navigation;
